/* eslint-disable no-undef */
import { frameLoader } from '../embeds/frames';
import renderUnemploymentRate from './unemployment-rate';
import renderSalesTaxRevenue from './sales-tax-revenue';
import renderUnemploymentClaims from './unemployment-claims';
import renderSalesTaxRevenueYoY from './sales-tax-revenue-yoy';

// import react components
import { h, render } from 'preact';
import UnemploymentRateMapGrid from '../components/UnemploymentRateMapGrid';

// chart is in the html of the embed
// depending on which embed, a different graphic is rendered
if (chart == 'unemployment-rate') {
  frameLoader(renderUnemploymentRate);
} else if (chart == 'sales-tax-revenue') {
  frameLoader(renderSalesTaxRevenue);
} else if (chart == 'unemployment-claims') {
  frameLoader(renderUnemploymentClaims);
} else if (chart == 'sales-tax-revenue-yoy') {
  frameLoader(renderSalesTaxRevenueYoY);
} else if (chart == 'county-unemployment-map') {
  render(
    <UnemploymentRateMapGrid />,
    document.getElementById('county-unemployment-map-grid')
  );
  frameLoader();
}
